import { XStylesSettings } from '@shared/types/types';
import { TextFieldProps } from '../model/types';
import * as stylex from '@stylexjs/stylex';
import Question from './assets/question';
import { styles } from './styles';
import Lock from './assets/lock';

const TextField = (props: TextFieldProps) => {
  const {
    isReadOnly = false,
    status = 'default',
    isDisabled = false,
    questionIcon,
    changeFunction,
    settings,
    'data-testid': testId,
  } = props;

  const { placeholder = 'Введите текст', value, textareaMessage, labelMsg = 'Текстовое поле *' } = props;

  const showMessage = status !== 'default' && Boolean(textareaMessage);

  const textareaNode = (
    <textarea
      data-testid={testId}
      disabled={isDisabled}
      readOnly={isReadOnly}
      value={value}
      placeholder={placeholder}
      onChange={changeFunction}
      {...stylex.props(styles.base(isDisabled, status), styles[status], settings as XStylesSettings)}
    />
  );

  return (
    <div {...stylex.props(styles.container, isDisabled && styles.containerDisabled)}>
      <div {...stylex.props(styles.aboveTextarea)}>
        {labelMsg && (
          <label htmlFor="myTextarea" {...stylex.props(styles.labelMsg(isDisabled, isReadOnly))}>
            {labelMsg}
          </label>
        )}
        {questionIcon && <Question />}
        {isReadOnly && !isDisabled && <Lock />}
      </div>

      {textareaNode}
      {showMessage && <div {...stylex.props(styles.textareaMessage(status))}>{textareaMessage}</div>}
    </div>
  );
};

export default TextField;
